<template>
  <div>
    <v-container class="container px-0 mb-8">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center">
          <h4 class="font-weight-light">
            {{ $t("heading.reseller.page.branding") }}
          </h4>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="px-0 py-0">
      <v-card elevation="4" class="mb-8">
        <v-card-text>
          <v-form class="" ref="form" v-model="formValid" lazy-validation>
            <v-row class="mb-2">
              <v-col 
                cols="12"
                sm="6"
                v-for="field of fields" :key="field.name"
                class="d-flex flex-column justify-center gray--text text--darken-4 py-2"
              >
              <label
                v-if="field.label"
                class="base--text p-3 mb-1"
                v-show="!field.hidden"
              >{{ field.label }}
              </label>
                <v-skeleton-loader
                  v-if="fetching"
                  type="list-item"
                ></v-skeleton-loader>
                <v-text-field
                  v-else
                  v-model="settings[field.name]"
                  :placeholder="field.placeholder"
                  outlined
                  hide-details="auto"
                  class="mb-0"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-btn
            class="ml-auto mt-4"
            elevation="0"
            color="primary"
            large
            @click="$root.$emit('style-manager-open')"
          >
            <v-icon class="mr-2">$settings2</v-icon>
            {{ $t("button.branding.manage") }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container class="container px-0 mb-8" v-if="settings.domain">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center">
          <h4 class="font-weight-light">
            {{ $t("heading.reseller.page.dnsrecord") }}
          </h4>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="px-0 py-0">
      <v-card elevation="4" class="mb-7" v-if="settings.domain">
        <v-card-text>
          <div class="alert alert--info-bg alert--sm alert--100">
            <div class="alert__icon-box">
              <v-icon color="info" size="20">$infoCircle</v-icon>
            </div>
            <div class="alert__text-box alert__text-box--wide d-flex flex-row">
              <strong>{{ $t("reseller.domain.dnsSetupInfo1") }}</strong>&nbsp;{{ $t("reseller.domain.dnsSetupInfo2") }}
            </div>
          </div>
          <div
            class="well well--gray py-3 px-4 mb-2"
            >
            <ul class="record-box-list">
              <li
                class="record-box-list-item"
                @click="copyElement($event)"
                @mouseover="hoveredIndex.spf = `1-name`"
                @mouseleave="hoveredIndex.spf = null, valueCopied = false"
              >
                <span>{{ $t("general.name") }}: </span>
                <span class="record-box-copy-element heading--text">
                  <span>{{ settings.domain }}</span>
                  <v-tooltip
                    open-delay="150"
                    bottom
                    content-class="copy-record-val-tooltip"
                    transition="custom-tooltip"
                    :value="hoveredIndex.spf === `1-name`"
                  >
                    <template v-slot:activator="{ attrs }">
                      <v-icon
                        class="copy-icon"
                        :size="16"
                        v-bind="attrs"
                      >
                        $copy
                      </v-icon>
                    </template>
                    <div>
                      <p class="p-3 mb-0 record-box-copy-element-tooltip">
                        <span v-if="valueCopied" class="copied primary--text">{{ $t('tooltip.copied') }}</span>
                        <span v-else class="copy">{{ $t('tooltip.copy') }}</span>
                      </p>
                    </div>
                  </v-tooltip>
                </span>
              </li>
              <li
                class="record-box-list-item"
                @click="copyElement($event)"
                @mouseover="hoveredIndex.spf = `2-type`"
                @mouseleave="hoveredIndex.spf = null, valueCopied = false"
              >
                <span>{{ $t("general.type") }}: </span>
                <span class="record-box-copy-element heading--text">
                  <span>CNAME</span>
                  <v-tooltip
                    open-delay="150"
                    bottom
                    content-class="copy-record-val-tooltip"
                    transition="custom-tooltip"
                    :value="hoveredIndex.spf === `2-type`"
                  >
                    <template v-slot:activator="{ attrs }">
                      <v-icon
                        class="copy-icon"
                        :size="16"
                        v-bind="attrs"
                      >
                        $copy
                      </v-icon>
                    </template>
                    <div>
                      <p class="p-3 mb-0 record-box-copy-element-tooltip">
                        <span v-if="valueCopied" class="copied primary--text">{{ $t('tooltip.copied') }}</span>
                        <span v-else class="copy">{{ $t('tooltip.copy') }}</span>
                      </p>
                    </div>
                  </v-tooltip>
                </span>
              </li>
              <li
                class="record-box-list-item"
                @click="copyElement($event)"
                @mouseover="hoveredIndex.spf = `3-address`"
                @mouseleave="hoveredIndex.spf = null, valueCopied = false"
              >
                <span>{{ $t("general.address") }}: </span>
                <span class="record-box-copy-element heading--text">
                  <span>{{ panelDomain }}</span>
                  <v-tooltip
                    open-delay="150"
                    bottom
                    content-class="copy-record-val-tooltip"
                    transition="custom-tooltip"
                    :value="hoveredIndex.spf === `3-address`"
                  >
                    <template v-slot:activator="{ attrs }">
                      <v-icon
                        class="copy-icon"
                        :size="16"
                        v-bind="attrs"
                      >
                        $copy
                      </v-icon>
                    </template>
                    <div>
                      <p class="p-3 mb-0 record-box-copy-element-tooltip">
                        <span v-if="valueCopied" class="copied primary--text">{{ $t('tooltip.copied') }}</span>
                        <span v-else class="copy">{{ $t('tooltip.copy') }}</span>
                      </p>
                    </div>
                  </v-tooltip>
                </span>
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
      <div>
          <v-btn
            :loading="submitting"
            elevation="0"
            class="ml-auto mt-4"
            color="primary"
            large
            @click="submit"
          >
            {{ $t("button.saveChanges") }}
          </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import Api from "../../apis/Api";
export default {
  components: {},
  props: {},
  data() {
    return {
      formValid: true,
      settings: {
        brand_name: "",
        domain: "",
      },
      fields: [
        {
          name: "brand_name",
          label: this.$t("reseller.brandName"),
          tooltip: this.$t("reseller.brandName.tooltip"),
          placeholder: this.$t("reseller.brandName.placeholder"),
        },
        {
          name: "domain",
          label: this.$t("reseller.domain"),
          tooltip: this.$t("reseller.domain.tooltip"),
          placeholder: this.$t("reseller.domain.placeholder"),
        },
      ],
      fetching: false,
      submitting: false,
      hoveredIndex: {
        spf: null,
        dkim: null
      },
      valueCopied: false,
    };
  },
  computed: {
    panelDomain() {
      return window.location.hostname;
    },
  },
  mounted() {
    // this.$root.$emit("style-manager-activator-show");
    // this.$root.$emit("style-manager-open");
    this.fetchSettings();
  },
  beforeDestroy() {
    // this.$root.$emit("style-manager-activator-hide");
    // this.$root.$emit("style-manager-close");
  },
  methods: {
    copyElement(event) {
      const el = event.currentTarget.querySelector(".record-box-copy-element");
      if (el) {
        const text = el.innerText || el.textContent;
        navigator.clipboard.writeText(text).then(() => {
          this.valueCopied = true;
        });
      }
    },
    fetchSettings() {
      this.fetching = true;
      Api.get(`/reseller/branding-settings`)
        .then((response) => {
          this.settings = {
            brand_name: response.data.data.brand_name,
            domain: response.data.data.domain,
          };
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitting = true;
      Api.put(`/reseller/branding-settings`, this.settings)
        .then(() => {
          this.$store.dispatch("addAlert", {
            success: true,
            successMessage: this.$t("message.alertManager.success"),
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
  .record {
  &-label {
    margin-left: 12px;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    padding: 3px 5px;
    border-radius: 5px;
    text-transform: capitalize;
    height: 24px;
    display: flex;
    align-items: center;

    &.failed {
      color: var(--v-error-base);
      background: rgba(231, 29, 29, 0.15);
    }

    &.configured {
      color: var(--v-primary-darken1);
      background: var(--v-primary-lighten2)
    }
  }

  &-box {
    &-title {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      color: var(--gray-pa-1100-headings, #21212B);
      font-size: 18px;
      line-height: 24px;
    }

    &-list {
      &-item {
        cursor: pointer;

        .copy-icon {
          transition: 0.3s;
          opacity: 0;
          visibility: hidden;
          margin-left: 4px;
          color: var(--v-primary-base);
        }

        &:hover {
          .copy-icon {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }

    &-copy-element-tooltip {
      width: 50px;
      text-align: center;
    }
  }
}
</style>